{
  "sidebar": {
    "documents": "Documentos",
    "sections": "Secciones",
    "allDocs": "Todos los documentos",
    "recent": "Recientes",
    "favorites": "Favoritos",
    "shared": "Compartidos",
    "private": "Privados",
    "folders": "Carpetas",
    "newFolder": "Nueva carpeta"
  },
  "toolbar": {
    "search": "Buscar archivos...",
    "upload": "Subir",
    "newFolder": "Carpeta",
    "viewList": "Vista de lista",
    "viewGrid": "Vista de cuadrícula",
    "selected": "{{count}} seleccionado(s)",
    "clearSelection": "Limpiar",
    "moveSelected": "Mover",
    "deleteSelected": "Eliminar",
    "sortBy": "Ordenar por",
    "sortByName": "Nombre",
    "sortBySize": "Tamaño",
    "sortByDate": "Fecha",
    "sortByUploader": "Subido por",
    "sortAsc": "Ascendente",
    "sortDesc": "Descendente"
  },
  "list": {
    "empty": "No hay archivos en este proyecto.",
    "emptyFolder": "Esta carpeta está vacía.",
    "columns": {
      "name": "Nombre",
      "size": "Tamaño",
      "uploadedBy": "Subido por",
      "date": "Fecha de subida"
    }
  },
  "item": {
    "preview": "Vista previa",
    "download": "Descargar archivo",
    "delete": "Eliminar archivo",
    "move": "Mover a carpeta",
    "rename": "Renombrar",
    "favorite": "Agregar a favoritos",
    "unfavorite": "Quitar de favoritos",
    "makePrivate": "Hacer privado",
    "makePublic": "Hacer público",
    "actions": "Acciones del archivo",
    "moveDialog": {
      "title": "Mover archivo",
      "folderLabel": "Carpeta destino",
      "root": "Raíz del proyecto"
    }
  },
  "file": {
    "deleteConfirmTitle": "¿Eliminar archivo?",
    "deleteConfirmDescription": "Esta acción no se puede deshacer. El archivo será eliminado permanentemente.",
    "bulkDeleteConfirmTitle": "¿Eliminar {{count}} archivos?",
    "bulkDeleteConfirmDescription": "Esta acción no se puede deshacer. Todos los archivos seleccionados serán eliminados permanentemente.",
    "bulkDeletePartialWarning": "{{count}} archivo(s) no pudieron eliminarse.",
    "renameDialogTitle": "Renombrar archivo",
    "renameLabel": "Nombre del archivo"
  },
  "folder": {
    "createDialogTitle": "Nueva carpeta",
    "renameDialogTitle": "Renombrar carpeta",
    "nameLabel": "Nombre de la carpeta",
    "parentLabel": "Carpeta padre (opcional)",
    "open": "Abrir",
    "rename": "Renombrar",
    "delete": "Eliminar carpeta",
    "move": "Mover carpeta",
    "actions": "Acciones de carpeta",
    "subfolderCount": "{{count}} subcarpeta",
    "subfolderCount_other": "{{count}} subcarpetas",
    "deleteConfirmTitle": "¿Eliminar carpeta?",
    "deleteConfirmDescription": "Solo puedes eliminar carpetas vacías. Esta acción no se puede deshacer."
  },
  "form": {
    "validation": {
      "nameRequired": "El nombre es obligatorio"
    }
  },
  "fileType": {
    "image": "Imagen",
    "pdf": "PDF",
    "sheet": "Hoja de cálculo",
    "slides": "Presentación",
    "document": "Documento",
    "video": "Video",
    "audio": "Audio",
    "archive": "Comprimido",
    "code": "Código",
    "file": "Archivo"
  },
  "preview": {
    "close": "Cerrar vista previa",
    "previous": "Archivo anterior",
    "next": "Archivo siguiente",
    "unsupported": "Vista previa no disponible para este tipo de archivo.",
    "loadError": "No se pudo cargar el archivo."
  },
  "apiErrors": {
    "uploadFailed": "No se pudo subir el archivo",
    "uploadFileTooLarge": "El archivo supera el tamaño permitido",
    "uploadInvalidType": "Tipo de archivo no permitido",
    "uploadForbidden": "No tienes permiso para subir archivos",
    "deleteFailed": "No se pudo eliminar el archivo",
    "deleteNotFound": "El archivo no fue encontrado",
    "deleteForbidden": "No tienes permiso para eliminar este archivo",
    "moveFailed": "No se pudo mover el archivo",
    "moveFileNotFound": "El archivo no fue encontrado",
    "moveFolderNotFound": "La carpeta destino no fue encontrada",
    "moveForbidden": "No tienes permiso para mover este archivo",
    "bulkDeleteFailed": "No se pudieron eliminar los archivos",
    "bulkDeleteForbidden": "No tienes permiso para eliminar estos archivos",
    "renameFailed": "No se pudo renombrar el archivo",
    "renameNotFound": "El archivo no fue encontrado",
    "renameConflict": "Ya existe un archivo con ese nombre",
    "renameForbidden": "No tienes permiso para renombrar este archivo",
    "favoriteFailed": "No se pudo actualizar el favorito",
    "favoriteNotFound": "El archivo no fue encontrado",
    "favoriteForbidden": "No tienes permiso para realizar esta acción",
    "visibilityFailed": "No se pudo cambiar la visibilidad",
    "visibilityNotFound": "El archivo no fue encontrado",
    "visibilityForbidden": "No tienes permiso para cambiar la visibilidad",
    "folderCreateFailed": "No se pudo crear la carpeta",
    "folderNameTaken": "Ya existe una carpeta con ese nombre",
    "folderCreateForbidden": "No tienes permiso para crear carpetas",
    "folderDeleteFailed": "No se pudo eliminar la carpeta",
    "folderNotEmpty": "La carpeta debe estar vacía para poder eliminarse",
    "folderNotFound": "La carpeta no fue encontrada",
    "folderDeleteForbidden": "No tienes permiso para eliminar esta carpeta",
    "folderRenameFailed": "No se pudo renombrar la carpeta",
    "folderRenameForbidden": "No tienes permiso para renombrar esta carpeta",
    "folderMoveFailed": "No se pudo mover la carpeta",
    "folderCircularReference": "No puedes mover una carpeta dentro de sí misma",
    "folderMoveForbidden": "No tienes permiso para mover esta carpeta"
  }
}
